import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ActivityComponent from './activityComponent';
import { semanticColors } from '../../Globals/styles';
import ActivityDropComponent from './activityDropComponent'
import Radium from 'radium';
import { Scrollbars } from 'react-custom-scrollbars';

class ColumnComponent extends Component {
  render() {
    const { params, title, activities, columnNumber, onActivityDrop,
      userRole, showSidebar, registerHours, draggingEmployee, setEmployeeHours,
      redirectTo, setActivityIsDragging, activityIsDragging, registrationDate } = this.props;
    var ActivityNodes = activities.map(function (activity, index) {
      if(!activity) {
        return null;
      }
      return (
        <div key={activity.id} style={styles.activityContainer}>
          <ActivityDropComponent
            index={index}
            columnNumber={columnNumber}
            onActivityDrop={onActivityDrop}
            isLast={false}
            activityIsDragging={activityIsDragging}
            activitiesLength={activities.length}
          />
          <ActivityComponent
            {...activity}
            registrationDate={registrationDate}
            currentColumnNumber={columnNumber}
            params={params}
            userRole={userRole}
            showSidebar={showSidebar}
            registerHours={registerHours}
            draggingEmployee={draggingEmployee}
            setEmployeeHours={setEmployeeHours}
            redirectTo={redirectTo}
            setActivityIsDragging={setActivityIsDragging}
            activityIsDragging={activityIsDragging}
          />
          {index === activities.length - 1 ?
            <ActivityDropComponent
              index={activities.length}
              columnNumber={columnNumber}
              onActivityDrop={onActivityDrop}
              redirectTo={redirectTo}
              setActivityIsDragging={setActivityIsDragging}
              activityIsDragging={activityIsDragging}
              isLast={true}
              activitiesLength={activities.length}
            />
            :
            null
          }
        </div>
      );
    });
    return (
      <div className="columnContainer" style={styles.column}>
        <h2 style={styles.h2}>{title}</h2>
        <Scrollbars style={{ width: '100%', height: '100%' }} autoHide={true}>
          {ActivityNodes.length ?
            ActivityNodes
            :
            <ActivityDropComponent
              index={0}
              columnNumber={columnNumber}
              onActivityDrop={onActivityDrop}
              redirectTo={redirectTo}
              setActivityIsDragging={setActivityIsDragging}
              activityIsDragging={activityIsDragging}
              isLast={false}
              isOnlyDropTarget={true}
              activitiesLength={activities.length}
            />
          }

        </Scrollbars>
      </div>
    );
  }
}
var styles = {
  column: {
    position: 'relative',
    backgroundColor: semanticColors.default,
    textAlign: 'center',
    height: '100%',
    borderRadius: '2px',
    boxShadow: '0 0px 1px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    padding: '47px 10px 10px 10px'
  },
  h2: {
    backgroundColor: semanticColors.default,
    fontWeight: 'bold',
    height: '35px',
    lineHeight: '45px',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    borderRadius: '2px'
  },
  activityContainer: {
    position: 'relative',
    marginBottom: '12px'
  }
}
ColumnComponent.propTypes = {
  params: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  activities: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    registered: PropTypes.number.isRequired,
    estimated: PropTypes.number.isRequired
  })),
  columnNumber: PropTypes.number.isRequired,
  onActivityDrop: PropTypes.func.isRequired,
  showSidebar: PropTypes.bool.isRequired,
  registerHours: PropTypes.func.isRequired,
  draggingEmployee: PropTypes.string,
  setEmployeeHours: PropTypes.func.isRequired,
  redirectTo: PropTypes.func.isRequired,
  setActivityIsDragging: PropTypes.func.isRequired,
  activityIsDragging: PropTypes.bool.isRequired
};
export default Radium(ColumnComponent);


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/columnComponent.jsx